import React from 'react'

import { RestrictedItemsList, RestrictedItemsListProps } from './RestrictedItemsList'
import {
  ShippingRestrictionsModal,
  ShippingRestrictionsModalProps,
} from './ShippingRestrictionsModal'
import { ModalMessage } from './styled'

export type CountryShippingRestrictionsModalProps = RestrictedItemsListProps &
  ShippingRestrictionsModalProps & {
    className?: string
  }

export const CountryShippingRestrictionsModal: React.FC<CountryShippingRestrictionsModalProps> = ({
  className,
  handleClose,
  handleContinue,
  handleRemoveItems,
  loading,
  open,
  removeItemsError,
  restrictedItems = [],
}) => {
  return (
    <ShippingRestrictionsModal
      className={className}
      handleClose={handleClose}
      handleContinue={handleContinue}
      handleRemoveItems={handleRemoveItems}
      loading={loading}
      open={open}
      removeItemsError={removeItemsError}
    >
      <ModalMessage variant="body2" gutterBottom>
        The following item(s) in your cart cannot be shipped to the country you&apos;ve selected:
      </ModalMessage>
      <RestrictedItemsList restrictedItems={restrictedItems} />
    </ShippingRestrictionsModal>
  )
}
